import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetHubPage from "../pages/SpreadsheetHubPage";
import ArticlePage from "../pages/ArticlePage";
import AboutPage from "../pages/AboutPage";
import DisclaimerPage from "../pages/DisclaimerPage";
import PrivacyPage from "../pages/PrivacyPage";
import TermsPage from "../pages/TermsPage";
import ContactPage from "../pages/ContactPage";
import EditorialPolicyPage from "../pages/EditorialPolicyPage";
import MethodologyPage from "../pages/MethodologyPage";
import { pillarArticles } from "../mocks/articles";

const articleRoutes: RouteObject[] = pillarArticles.map((article) => ({
  path: `/${article.slug}/`,
  element: <ArticlePage slug={article.slug} />,
}));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet/",
    element: <SpreadsheetHubPage />,
  },
  ...articleRoutes,
  {
    path: "/about/",
    element: <AboutPage />,
  },
  {
    path: "/disclaimer/",
    element: <DisclaimerPage />,
  },
  {
    path: "/privacy/",
    element: <PrivacyPage />,
  },
  {
    path: "/terms/",
    element: <TermsPage />,
  },
  {
    path: "/contact/",
    element: <ContactPage />,
  },
  {
    path: "/editorial-policy/",
    element: <EditorialPolicyPage />,
  },
  {
    path: "/methodology/",
    element: <MethodologyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;